import type { MetadataApiSpecInfo } from "../contracts/utils/metadata/MetadataApiSpecInfo";
import { BacklogError } from "../errors/BacklogError";
import type { RequestMethod } from "../types/RequestMethod";
import { MetadataApiSpecInfo as MetadataApiSpecInfoImpl } from "../utils/metadata/MetadataApiSpecInfo";
import type { ApiSpecMetadataJson } from "./MetadataJson";

const api_spec_list_metadata = new (class {
	private init = false;
	private api_spec_list: ApiSpecMetadataJson[] = [];

	addApiSpec(api_spec_list: ApiSpecMetadataJson[]) {
		this.api_spec_list.push(...api_spec_list);
		this.init = true;
	}

	getApiSpec(
		endpoint: string,
		method: RequestMethod,
	): ApiSpecMetadataJson | undefined {
		if (!this.init) {
			throw new BacklogError(
				"Metadata not loaded: To use metadata, you need to call `loadBacklogMetadata()` beforehand.",
			);
		}
		for (const spec of this.api_spec_list) {
			if (spec.endpoint === endpoint && spec.method === method) {
				return spec;
			}
		}
		return undefined;
	}

	createMetadataApiSpecInfo(
		api_spec: ApiSpecMetadataJson,
	): MetadataApiSpecInfo {
		return new MetadataApiSpecInfoImpl(api_spec);
	}
})();

export function registerApiSpecMetadata(callback: () => ApiSpecMetadataJson[]) {
	api_spec_list_metadata.addApiSpec(callback());
}

export function getApiSpecMetadata(): {
	getApiSpec(
		endpoint: string,
		method: RequestMethod,
	): ApiSpecMetadataJson | undefined;
	createMetadataApiSpecInfo(api_spec: ApiSpecMetadataJson): MetadataApiSpecInfo;
} {
	return api_spec_list_metadata;
}
